document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById("myVideo");

  video.play().catch((error) => {
    console.error("Autoplay failed:", error);
  });

  video.autoplay = true;
  video.loop = true;
  video.muted = true;

  video.removeAttribute("controls");

  window.addEventListener("scroll", function() {
    if (!video.paused) {
      return;
    }
    video.play().catch((error) => {
      console.error("Autoplay failed after scroll:", error);
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
    const element = document.querySelector(".product_detail-des");
    const content = element.textContent.trim(); // Get the text content
    const items = JSON.parse(content); // Convert array-like string to an array

    // Clear the existing content and append each item as a styled <span>
    element.innerHTML = ""; // Clear current content
    items.forEach(item => {
        const span = document.createElement("span");
        span.textContent = item;
        span.style.display = "block"; // Ensure each item appears on a new line
        span.style.fontSize = "20px"; // Set font size
        span.style.fontWeight = "600"; // Set font weight
        span.style.color = "#092143"; // Set font weight
        span.style.lineHeight = "1.8em"; // Set line height
        element.appendChild(span);
    });
});


document.addEventListener("DOMContentLoaded", function () {
    const productNames = document.querySelectorAll(".product-item__name");

    productNames.forEach(productName => {
        // Get computed styles
        const style = window.getComputedStyle(productName);
        const lineHeight = parseFloat(style.lineHeight);
        const height = productName.offsetHeight;

        // Calculate the number of lines
        const numberOfLines = Math.round(height / lineHeight);

        // Apply margin based on number of lines
        if (numberOfLines === 1) {
            productName.style.marginBottom = "20px"; // Add space for one-line text
        } else {
            productName.style.marginBottom = "0"; // Remove space for multi-line text
        }
    });
});
